/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */

export type VendorApiResourceType = typeof VendorApiResourceType[keyof typeof VendorApiResourceType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VendorApiResourceType = {
  vendor: 'vendor',
} as const;
